import { useUI } from '@context/GlobalUIContext';
import { useTranslation } from 'next-i18next';
import SimpleButton from '_components/UI/SimpleButton';

import styles from './SelectStoreMessage.module.scss';

const SelectStoreMessage = () => {
  const { t } = useTranslation('pdp');
  const { openStockLevelModal } = useUI();

  return (
    <span className={styles.selectStoreMessage}>
      {t('product.free.store.pickup.select.store.select')}{' '}
      <SimpleButton
        variant="secondary"
        size="small"
        mode="light"
        onClick={() => openStockLevelModal()}
        className={styles.storeNameButton}
      >
        {t('product.free.store.pickup.select.store.button')}
      </SimpleButton>{' '}
      {t('product.free.store.pickup.select.store.to.view.pickup.availability')}
    </span>
  );
};

export default SelectStoreMessage;
